import {Component, Input, OnInit} from '@angular/core';
import {DocumentTypeModel} from '../../../shared/dto/document-type.model';
import {ApplicantRequestService} from '../../../service/applicant-request.service';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {DocumentDetailsService} from '../../../service/document-details.service';
import {DocumentViewerComponent} from '../document-viewer/document-viewer.component';
import {MatTableDataSource} from '@angular/material/table';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {DocumentViewerPopupComponent} from '../document-viewer-popup/document-viewer-popup.component';

@Component({
  selector: 'app-document-viwer-popup',
  templateUrl: './document-viwer-popup.component.html',
  styleUrls: ['./document-viwer-popup.component.scss']
})
export class DocumentViwerPopupComponent implements OnInit {
  @Input() applicationId: number;
  @Input() fromParent;
  public documentTypeModel: DocumentTypeModel[];
  displayedColumns: string[] = ['description','action'];
  dataSource: MatTableDataSource<any>;
  public pages: any = [];
  public loader: boolean = false;
  public safeUrl: SafeResourceUrl;
  docType: DocumentTypeModel = new DocumentTypeModel();
  isLoading: boolean = false;
  public application: number;

  constructor(private applicantRequestService: ApplicantRequestService, private documentDetailsService: DocumentDetailsService,
              private sanitizer: DomSanitizer, private modalService: NgbModal,) { }

  ngOnInit() {
    this.getDocumentType();
    this.application = this.applicationId;
  }

  getDocumentType() {
    this.isLoading = true;
    this.applicantRequestService.getDocumentType(this.fromParent.application).subscribe(
      (result: any ) => {
        this.isLoading = false;
        this.documentTypeModel = result;
        this.dataSource = new MatTableDataSource(this.documentTypeModel);
      }
    );
  }

  transform(base64Image) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(base64Image);
  }

  viewDoc(documentTypeCode:string) {
    this.docType.appRefID = this.fromParent.application;
    this.docType.documentTypeCode = documentTypeCode;

    const modalRef = this.modalService.open(DocumentViewerPopupComponent,{size: 'md'});
    let data = {
      doc: this.docType,
    }

    modalRef.componentInstance.fromParent = data;
  }

}
